import React from 'react';
import './Buttons.scss';

const Buttons = ({title, value ,onClick, selected}) => {

    return (
        <button className={`buttons ${selected ? 'selected' : ''}`} onClick={() => onClick()}>
            {title}            
        </button>
    )
}

export default Buttons;